import { render, staticRenderFns } from "./FlowPage.vue?vue&type=template&id=a58cb166&scoped=true&"
import script from "./FlowPage.vue?vue&type=script&lang=js&"
export * from "./FlowPage.vue?vue&type=script&lang=js&"
import style0 from "./FlowPage.vue?vue&type=style&index=0&id=a58cb166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58cb166",
  null
  
)

export default component.exports